module.exports = __webpack_public_path__ + "static/media/img5.b54853b1.jpg";